import omit from "lodash/omit"
import { Model, Schema } from "src/engine/modules/model/classes"

const entityName = `events/types`

export default new Model({
  name: entityName,
  getRestUrn: (method, id) => (id ? `${entityName}/${id}` : `${entityName}`),
  denormalize: data => omit(data, [`id`]),
  schema: new Schema({}),
})
